module.exports = __webpack_public_path__ + "static/media/product-placeholder.fab431c4.png";